import { type ECommerceProduct } from '@hooks-api/types/dataModel/products'
import { Divider } from '@pets-ui/Divider/Divider'
import { VStack } from '@pets-ui/VStack/VStack'
import { useMemo } from 'react'
import { CouponProductSelectorItemVariationList } from './CouponProductSelectorItemVariationList'

type GroupByParentProductId = Map<number, {
  parentProduct: {
    id: number
    name: string
    thumbnail: string
  }
  products: ECommerceProduct[]
}>

export type CouponProductToggleVariationHandler = (variations: ECommerceProduct[], isOpen: boolean) => void
export interface CouponProductSelectorItemProps {
  groupIndex: number
  products: ECommerceProduct[]
  onToggleCouponProduct?: CouponProductToggleVariationHandler
}

export const CouponProductSelectorItem = (props: CouponProductSelectorItemProps) => {
  const { groupIndex, products, onToggleCouponProduct } = props
  const groupByParentProductId = useMemo(() =>
    products.reduce<GroupByParentProductId>((acc, product) => {
      acc.set(product.parent_product_id, {
        parentProduct: {
          id: product.parent_product_id,
          name: product.name,
          thumbnail: product.thumbnail || '',
        },
        products: [...(acc.get(product.parent_product_id)?.products || []), product],
      })
      return acc
    }, new Map()), [products])

  const groupByParentProductIdArray = useMemo(() => Array.from(groupByParentProductId.values()), [groupByParentProductId])

  return (
    <VStack divider={<Divider />}>
      {groupByParentProductIdArray.map((groupByParentProductId) => {
        const handleExpandProduct = (isOpen: boolean) => {
          onToggleCouponProduct?.(groupByParentProductId.products, isOpen)
        }
        return (
          <CouponProductSelectorItemVariationList
            key={`${groupIndex}-${groupByParentProductId.parentProduct.id}`}
            name={groupByParentProductId.parentProduct.name}
            thumbnail={groupByParentProductId.parentProduct.thumbnail}
            products={groupByParentProductId.products}
            onToggleCouponProduct={handleExpandProduct}
          />
        )
      })}
    </VStack>
  )
}
